import { Formik } from "formik";
import { useEffect, useMemo, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import * as Yup from "yup";

import Button from "../../../../../../common/Button/Button";
import InputFormik from "../../../../../../common/Formik/Input/InputFormik";
import Select from "../../../../../../common/Formik/Select/Select";
import style from "./CardTypeApply.module.scss";
import csc from "country-state-city";

import {
  ALLOWED_ISO_CODES,
  APPLY_CARD_SHIPPING_PREFILL_KEY,
  COUNTRY_OF_ISSUE_OPTIONS,
  FORMIK_REGEX,
  Messages,
  countryByIso,
  getPhoneCodeByCountryIso,
} from "../../../../../../../utils/constants";
import { validationMessage } from "../../../../../../../Helper/helperfunction";
import {
  applyCardApplicationAction,
  applyRainCardAction,
  cardDataAction,
  cardDetailsAction,
  getGlobalCardSettingsAction,
  getUserCoinListAction,
} from "../../../../../../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import IssuedCardSuccessModal from "../../../../../../common/Modals/IssuedCardSuccessModal/IssuedCardSuccessModal";

const mapApplyResponseToIssuedCard = (response, formValues, selectedCardType) => {
  const root = response?.data?.data ?? response?.data ?? {};
  const card = root.card ?? root;
  const application = card.application ?? root.application ?? {};

  const rawFour = card.last_four ?? root.last_four;
  let lastFour = "****";
  if (rawFour != null && String(rawFour).length > 0) {
    const digits = String(rawFour).replace(/\D/g, "");
    if (digits.length > 0) {
      lastFour = digits.slice(-4).padStart(4, "0");
    }
  }

  const em = card.expiry_month ?? root.expiry_month;
  const ey = card.expiry_year ?? root.expiry_year;
  let expiryLabel = null;
  if (em != null && em !== "" && ey != null && ey !== "") {
    const yearStr = String(ey);
    const fullYear =
      yearStr.length <= 2 ? `20${yearStr.padStart(2, "0")}` : yearStr;
    expiryLabel = `${Number(em)}/${fullYear}`;
  }

  const display = formValues.displayName?.trim();
  const fn = application.first_name?.trim();
  const ln = application.last_name?.trim();
  const holderName =
    display || [fn, ln].filter(Boolean).join(" ").trim() || "Card holder";

  const st = (card.status ?? root.status ?? "approved").toString().toLowerCase();
  const statusText =
    st === "active" || st === "approved"
      ? "Approved"
      : st.charAt(0).toUpperCase() + st.slice(1);

  return {
    lastFour,
    holderName,
    expiryLabel,
    statusText,
    cardCategory: formValues.cardCategory?.value,
    cardType: selectedCardType,
  };
};

const pickMatchingListCard = (cards, cardType, cardCategoryValue) => {
  const list = Array.isArray(cards) ? cards : [];
  const active = list.filter(
    (c) => c.card_type === cardType && c.status !== "canceled"
  );
  const pool = active.length ? active : list.filter((c) => c.card_type === cardType);
  if (!pool.length) return null;
  if (
    cardCategoryValue &&
    pool.some((c) => c.card_form === cardCategoryValue)
  ) {
    return pool.find((c) => c.card_form === cardCategoryValue) || pool[0];
  }
  return pool[0];
};

const mapCardDataDetailsToIssued = (d, formValues) => {
  if (!d) return null;
  const application = d.application ?? {};
  const rawFour = d.last_four;
  let lastFour = null;
  if (rawFour != null && String(rawFour).length > 0) {
    const digits = String(rawFour).replace(/\D/g, "");
    if (digits.length > 0) {
      lastFour = digits.slice(-4).padStart(4, "0");
    }
  }
  const em = d.expiry_month;
  const ey = d.expiry_year;
  let expiryLabel = null;
  if (em != null && em !== "" && ey != null && ey !== "") {
    const yearStr = String(ey);
    const fullYear =
      yearStr.length <= 2 ? `20${yearStr.padStart(2, "0")}` : yearStr;
    expiryLabel = `${Number(em)}/${fullYear}`;
  }
  const display = formValues.displayName?.trim();
  const fn = application.first_name?.trim();
  const ln = application.last_name?.trim();
  const fromKyc = [fn, ln].filter(Boolean).join(" ").trim();
  const holderName = fromKyc || display || null;
  const st = (d.status ?? "approved").toString().toLowerCase();
  const statusText =
    st === "active" || st === "approved"
      ? "Approved"
      : st.charAt(0).toUpperCase() + st.slice(1);
  return { lastFour, expiryLabel, holderName, statusText };
};

const mergeIssuedPreferFetched = (base, patch) => {
  if (!patch) return base;
  const useFour =
    patch.lastFour && patch.lastFour !== "****" ? patch.lastFour : base.lastFour;
  return {
    ...base,
    lastFour: useFour,
    expiryLabel: patch.expiryLabel || base.expiryLabel,
    holderName: patch.holderName || base.holderName,
    statusText: patch.statusText || base.statusText,
  };
};

const CardTypeApply = ({ onClick }) => {
  const [coinList, setCoinlist] = useState([])
  const [loading, setLoading] = useState(false);
  const [showIssuedModal, setShowIssuedModal] = useState(false);
  const [issuedCardDetails, setIssuedCardDetails] = useState(null);
  const [applicationId, setApplicationId] = useState(null);
  const [maxCardBalance, setMaxCardBalance] = useState(0);

  const updatedStates = (countryId) =>
    csc.getStatesOfCountry(countryId).map((state) => ({
      label: state.name,
      value: state.id,
      ...state,
    }));

  const cardTypeOptions = [
    { value: "DEBIT", label: "STBL Card" },
    { value: "CREDIT", label: "Credit Card" },
  ];

  // const cardCategoryOptions = [
  //   { value: "PHYSICAL", label: "Physical Card" },
  //   { value: "VIRTUAL", label: "Virtual Card" },
  // ];
const selectedCardCategoryOption = {
  value: "VIRTUAL",
  label: "Virtual Card",
};
  const min = 0;
  const max = 3000000;
  const [value, setValue] = useState(1);
  const dispatch = useDispatch();
  const typeCard = localStorage.getItem("cardType")
  const cardtype = useSelector(
    (state) => state?.users?.selectedCard?.card_type
  ) || typeCard;
  /* ===================== VALIDATION ===================== */
  const validationSchema = Yup.object({
    cardType: Yup.object().nullable().required(validationMessage("Card Type")),

    cardCategory: Yup.object()
      .nullable()
      .required(validationMessage("Card Category")),

    selectedAmount: Yup.number()
      .typeError("Selected Amount must be a number")
      .max(maxCardBalance, `Selected Amount must be at most ${maxCardBalance}`)
      .when("$cardtype", {
        is: () => cardtype !== "DEBIT",
        then: (schema) =>
          schema
            .required(validationMessage("Selected Amount"))
            .min(1, "Selected Amount must be at least 1"),
        otherwise: (schema) => schema.notRequired()
      }),

    address: Yup.string()
      .min(4)
      .required(validationMessage("Address"))
      .max(200, "Address must be at most 200 characters"),


    countryOfIssue: Yup.string()
      .required(validationMessage("Country of Issue"))
      .oneOf(ALLOWED_ISO_CODES, "This country is not available"),

    region: Yup.object().nullable().required(validationMessage("Region")),

    city: Yup.string()
      .max(60, "City must be at most 60 characters")
      .required(validationMessage("City"))
      .matches(FORMIK_REGEX.ALPHASPACE, Messages.ALPHABETSVALIDATION),

    // postalCode: Yup.string()
    //   .required(validationMessage("Postal Code"))
    //   .matches(FORMIK_REGEX.NUMBER, Messages.NUMBERVALIDATION)
    //   .min(4)
    //   .max(20, "Postal Code must be at most 20 characters"),
     postalCode: Yup.string()
      .required(validationMessage("Postal Code"))
      .matches(/^\S.*$/, "Postal Code must not start with a space") .matches(/.*\S$/, "Postal Code must not end with a space")
.matches(
  /^(?=.*[A-Za-z0-9])[A-Za-z0-9]+(?:[ -][A-Za-z0-9]+)*$/,
  "Please enter a valid postal code"
)
        .min(4, "Postal Code must be at least 4 characters")
      .max(20, "Postal Code must be at most 20 characters"),


    displayName: Yup.string()
      .label("Display Name")
      .matches(FORMIK_REGEX.ALPHASPACE, Messages.ALPHABETSVALIDATION)
      .min(3)
      .max(26),

    countryCode: Yup.string()
      .required(validationMessage("Country Code"))
      .oneOf(ALLOWED_ISO_CODES, "This country is not available"),

    phoneCountryCode: Yup.string().required(
      validationMessage("Phone Country Code"),
    ),

    phoneNumber: Yup.string()
      .min(6, "Phone Number must be at least 6 digits")
      .max(15, "Phone Number must be at most 15 digits")
      .required(validationMessage("Phone Number"))
      .matches(FORMIK_REGEX.NUMBER, Messages.NUMBERVALIDATION),

    coinList: Yup.object()
      .nullable()
      .when("$cardtype", {
        is: () => cardtype === "CREDIT",
        then: (schema) =>
          schema.required(validationMessage("Please Select Coin")),
        otherwise: (schema) => schema.notRequired(),
      })
  });
  const selectedCardTypeOption =
    cardTypeOptions.find((opt) => opt.value === cardtype) || null;

  const getApplicationId = async () => {
    try {
      const res = await dispatch(applyCardApplicationAction());
      if (res?.status === 200) {
        setApplicationId(res?.data?.data?.id)
      } else {
        setApplicationId(null);
      }
    } catch (error) {
      console.log(error, "error");
    }
  }

  useEffect(() => {
    getApplicationId()
  }, [])

  const handleFormSubmit = async (values) => {
    setLoading(true)
    try {
      const payload = {
        type: values.cardCategory?.value?.toLowerCase(),
        tokenId: "1",
        card_type: selectedCardTypeOption.value,
        limit: {
          amount: values.selectedAmount,
        },
        shipping: {
          line1: values.address,
          city: values.city,
          region: values.region?.label,
          postalCode: values.postalCode,
          countryCode: values.countryCode,
          phoneCountryCode: values.phoneCountryCode,
          phoneNumber: values.phoneNumber,
        },
        ...(values.displayName && {
          configuration: { displayName: values.displayName },
        }),
        ...(cardtype === "CREDIT" && { tokenId: values.coinList?.value })
      };
      const response = await dispatch(applyRainCardAction(payload, applicationId));
      if (response?.status === 200) {
        try {
          sessionStorage.removeItem(APPLY_CARD_SHIPPING_PREFILL_KEY);
        } catch {
          /* ignore */
        }
        let details = mapApplyResponseToIssuedCard(
          response,
          values,
          selectedCardTypeOption.value
        );
        try {
          const listRes = await dispatch(cardDetailsAction());
          if (listRes?.status === 200) {
            const cards = Array.isArray(listRes?.data?.data)
              ? listRes.data.data
              : [];
            const row = pickMatchingListCard(
              cards,
              selectedCardTypeOption.value,
              values.cardCategory?.value
            );
            if (row?.rain_card_id) {
              try {
                const detailRes = await dispatch(
                  cardDataAction(row.rain_card_id)
                );
                if (detailRes?.status === 200) {
                  const refined = mapCardDataDetailsToIssued(
                    detailRes?.data?.data,
                    values
                  );
                  details = mergeIssuedPreferFetched(details, refined);
                }
              } catch {
                /* keep merged-from-apply details */
              }
            }
          }
        } catch {
          /* list / details fetch failed — still show apply response */
        }
        setIssuedCardDetails(details);
        setShowIssuedModal(true);
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoading(false)
    }
  };

  const getCoinList = async () => {
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response?.status === 200) {
        const coinList = response?.data?.data?.coinList || [];
        const options = coinList
          .filter((coin) => coin.coin_name === "Gold" || coin.coin_name === "Silver")
          .map((coin) => ({ value: coin.id, label: coin.coin_name.toUpperCase() }));
        setCoinlist(options);
      }
    } catch (error) {
      console.error("Coin list error:", error);
    }
  };

  useEffect(() => {
    getCoinList()
  }, [])

  const getGlobalCardDetails = async () => {
    const res = await dispatch(getGlobalCardSettingsAction(cardtype));
    if (res?.status === 200 || res?.status === 201) {
      const d = res?.data?.data;
      setMaxCardBalance(d?.maximum_card_balance);
    }
  };

  useEffect(() => {
    getGlobalCardDetails()
  }, []);

  const formInitialValues = useMemo(() => {
    let prefill = null;
    try {
      const raw = sessionStorage.getItem(APPLY_CARD_SHIPPING_PREFILL_KEY);
      if (raw) prefill = JSON.parse(raw);
    } catch {
      prefill = null;
    }

    const countryOfIssue =
      prefill?.countryOfIssue || prefill?.countryCode || "US";
    const selectedCountry = countryByIso(countryOfIssue);
    let region = null;
    if (
      selectedCountry &&
      prefill?.regionValue != null &&
      prefill.regionValue !== ""
    ) {
      region =
        csc
          .getStatesOfCountry(selectedCountry.id)
          .map((state) => ({
            label: state.name,
            value: state.id,
            ...state,
          }))
          .find((o) => String(o.value) === String(prefill.regionValue)) || null;
    }

    return {
      cardType: selectedCardTypeOption,
      cardCategory: selectedCardCategoryOption,
      selectedAmount: 1,
      address: prefill?.address || "",
      city: prefill?.city || "",
      postalCode: prefill?.postalCode || "",
      countryCode: prefill?.countryCode || countryOfIssue || "US",
      countryOfIssue,
      region,
      phoneCountryCode:
        prefill?.phoneCountryCode || getPhoneCodeByCountryIso(countryOfIssue),
      phoneNumber: prefill?.phoneNumber || "",
      displayName: "",
      coinList: null,
    };
  }, [selectedCardTypeOption]);

  return (
    <>
      <div className={style.cardTypeApply}>
        <Formik
          enableReinitialize
          initialValues={formInitialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => handleFormSubmit(values)}
        >
          {(formik) => {
            const handleSliderChange = (e) => {
              const val = Number(e.target.value);
              setValue(val);
              formik.setFieldValue("selectedAmount", val);
            };

            const handleInputChange = (e) => {
              const val = Number(e.target.value);
              if (val >= min && val <= max) {
                setValue(val);
                formik.setFieldValue("selectedAmount", val);
              }
            };

            const selectedCountry = countryByIso(formik.values.countryOfIssue);
            const regionOptions = selectedCountry
              ? updatedStates(selectedCountry.id)
              : [];

            return (
              <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <div className={style.infoCards}>
                  <h4>Apply Rain Card</h4>
                  <div className={style.infoCards_innerform}>
                    <Row>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <Select
                          variant="xlarge_height"
                          label="Card Type"
                          name="cardType"
                          options={cardTypeOptions}
                          value={formik.values.cardType}
                          isDisabled={true}
                          isSearchable={false}
                          formik={formik}
                          components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                          }}
                        />
                      </Col>

                      {/* <Col xxl={3} xl={3} lg={4} md={6}>
                        <Select
                          variant="xlarge_height"
                          className="select_time"
                          label="Card Category"
                          name="cardCategory"
                          options={cardCategoryOptions}
                          value={formik.values.cardCategory}
                          onChange={(value) =>
                            formik.setFieldValue("cardCategory", value)
                          }
                          isSearchable={false}
                          formik={formik}
                        />
                      </Col> */}

<Col xxl={3} xl={3} lg={4} md={6}>
  <Select
    variant="xlarge_height"
    label="Card Category"
    name="cardCategory"
    options={[selectedCardCategoryOption]}
    value={selectedCardCategoryOption}
    isDisabled={true}
    isSearchable={false}
    formik={formik}
    components={{
      DropdownIndicator: () => null,
      IndicatorSeparator: () => null,
    }}
  />
</Col>
                      {cardtype !== "DEBIT" && <Col lg={6}>
                        <div className={style.wrapper}>
                          <div className={style.rangeBox}>
                            <div className={style.rangelabelfields}>
                              <label className={style.min}>Min: {min}</label>
                              <label className={style.max}>Max: {maxCardBalance}</label>
                            </div>
                            <input
                              type="range"
                              min={min}
                              max={maxCardBalance}
                              value={value}
                              className={style.range}
                              onChange={handleSliderChange}
                            />
                          </div>
                          <div className={style.inputBox}>
                            <InputFormik
                              variant="large_height"
                              name="selectedAmount"
                              label="Selected Amount"
                              type="number"
                              value={formik.values.selectedAmount}
                              onChange={handleInputChange}
                              formik={formik}
                            />
                          </div>
                        </div>
                      </Col>}

                      {formik.values.cardCategory?.value === "PHYSICAL" &&
                        <Col xxl={3} xl={3} lg={4} md={6}>
                          <InputFormik
                            variant="large_height"
                            name="displayName"
                            label="Card Display Name"
                            placeholder="Enter Name"
                            className="fieldinput"
                            {...formik.getFieldProps("displayName")}
                            formik={formik}
                          />
                        </Col>}

                      {cardtype === "CREDIT" &&
                        <Col xxl={3} xl={3} lg={4} md={6}>
                          <Select
                            variant="xlarge_height"
                            className="select_time"
                            label="Select Coin"
                            name="coinList"
                            options={coinList}
                            value={formik.values.coinList}
                            onChange={(value) =>
                              formik.setFieldValue("coinList", value)
                            }
                            isSearchable={false}
                            formik={formik}
                          />
                        </Col>}
                    </Row>
                  </div>
                </div>

                <div className={style.infoCards}>
                  <h4>Address Details</h4>
                  <div className={style.infoCards_innerform}>
                    <Row>
                      <Col xxl={6} xl={6} lg={6} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="address"
                          label="Street Address (House No., Building, Street, Landmark)"
                          placeholder="Enter Address"
                          className="fieldinput"
                          {...formik.getFieldProps("address")}
                          formik={formik}
                        />
                      </Col>

                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <Select
                          variant="xlarge_height"
                          className="select_time"
                          label="Country of Issue"
                          name="countryOfIssue"
                          placeholder={<h6>Select country</h6>}
                          options={COUNTRY_OF_ISSUE_OPTIONS}
                          value={
                            COUNTRY_OF_ISSUE_OPTIONS.find(
                              (o) => o.value === formik.values.countryOfIssue
                            ) || null
                          }
                          onChange={(opt) => {
                            if (!opt) return;
                            formik.setFieldValue("countryOfIssue", opt.value);
                            formik.setFieldValue("countryCode", opt.value);
                            formik.setFieldValue(
                              "phoneCountryCode",
                              getPhoneCodeByCountryIso(opt.value)
                            );
                            formik.setFieldValue("region", null);
                          }}
                          isSearchable
                          formik={formik}
                        />
                      </Col>

                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <Select
                          variant="xlarge_height"
                          className="select_time"
                          label="Region"
                          name="region"
                          placeholder={<h6>Select Region</h6>}
                          options={regionOptions}
                          value={formik.values.region}
                          onChange={(value) =>
                            formik.setFieldValue("region", value)
                          }
                          isSearchable
                          formik={formik}
                        />
                      </Col>

                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="city"
                          label="City"
                          placeholder="Enter City"
                          className="fieldinput"
                          {...formik.getFieldProps("city")}
                          formik={formik}
                        />
                      </Col>

                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="postalCode"
                          label="Postal Code"
                          placeholder="Enter Postal Code"
                          className="fieldinput"
                          {...formik.getFieldProps("postalCode")}
                          formik={formik}
                        />
                      </Col>

                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          className="fieldinput"
                          label="Country Code"
                          name="countryCode"
                          placeholder="US"
                          value={formik.values.countryCode}
                          onChange={(e) => {
                            const raw = e.target.value
                              .toUpperCase()
                              .replace(/[^A-Z]/g, "")
                              .slice(0, 2);
                            formik.setFieldValue("countryCode", raw);
                            if (raw.length === 2) {
                              const c = countryByIso(raw);
                              if (c) {
                                formik.setFieldValue(
                                  "countryOfIssue",
                                  c.sortname.toUpperCase()
                                );
                                formik.setFieldValue(
                                  "phoneCountryCode",
                                  getPhoneCodeByCountryIso(raw)
                                );
                                formik.setFieldValue("region", null);
                              }
                            }
                          }}
                          onBlur={formik.handleBlur}
                          disabled
                          formik={formik}
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="phoneCountryCode"
                          label="Phone Country Code"
                          placeholder="e.g. 1"
                          className="fieldinput"
                          {...formik.getFieldProps("phoneCountryCode")}
                          formik={formik}
                          disabled
                        />
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6}>
                        <InputFormik
                          variant="large_height"
                          name="phoneNumber"
                          label="Phone Number"
                          placeholder="Enter Phone Number"
                          className="fieldinput"
                          {...formik.getFieldProps("phoneNumber")}
                          formik={formik}
                        />
                      </Col>
                    </Row>
                  </div>
                  {formik.values.cardCategory?.value === "PHYSICAL" && <p style={{ color: "#d32f2f", fontSize: "13px", marginTop: "6px" }}>
                    Note: For physical cards, charges will be deducted for the metal card and shipping.
                  </p>}
                </div>

                {/* <div style={{ color: 'red', margin: '10px 0', fontSize: '13px' }}>
                  {Object.keys(formik.errors).length > 0 && (
                    <>Form has errors: {JSON.stringify(formik.errors)}</>
                  )}
                  {!formik.isValid && ' → form is invalid'}
                  {formik.isSubmitting && ' → is submitting'}
                </div> */}

                <Button
                  className={style.btn_Size}
                  type="button"
                  disabled={loading || !formik.isValid}
                  onClick={(e) => {
                    formik.handleSubmit(e);
                  }}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
              </form>
            );
          }}
        </Formik>
      </div>
      {showIssuedModal && issuedCardDetails && (
        <IssuedCardSuccessModal
          show={showIssuedModal}
          handleClose={() => {
            setShowIssuedModal(false);
            setIssuedCardDetails(null);
          }}
          lastFour={issuedCardDetails.lastFour}
          holderName={issuedCardDetails.holderName}
          expiryLabel={issuedCardDetails.expiryLabel}
          statusText={issuedCardDetails.statusText}
          cardCategory={issuedCardDetails.cardCategory}
          cardType={issuedCardDetails.cardType}
        />
      )}
    </>
  );
};

export default CardTypeApply;
